// Cálculo local (vista previa) del plan: inicio = max(desfase, fin de predecesores); ruta crítica hacia atrás.
export function previewPlan(activities) {
    const byKey = Object.fromEntries(activities.map(a => [a.key, a]));
    const plan = {};
    const visiting = new Set();
    const calc = (k) => {
        if (plan[k]) return plan[k];
        if (visiting.has(k) || !byKey[k]) return null;
        visiting.add(k);
        const a = byKey[k];
        let s = Number(a.offset_min) || 0;
        for (const p of a.predecessors || []) {
            const pp = calc(p);
            if (!pp) { visiting.delete(k); return null; }
            s = Math.max(s, pp[1]);
        }
        visiting.delete(k);
        plan[k] = [s, s + (Number(a.duration_min) || 0)];
        return plan[k];
    };
    for (const a of activities) if (!calc(a.key)) return null;
    const hasSucc = new Set(activities.flatMap(a => a.predecessors || []));
    const end = Math.max(...Object.values(plan).map(v => v[1]));
    const crit = new Set();
    const stack = activities.filter(a => !hasSucc.has(a.key) && Math.abs(plan[a.key][1] - end) < 0.01).map(a => a.key);
    while (stack.length) {
        const k = stack.pop();
        if (crit.has(k)) continue;
        crit.add(k);
        for (const p of byKey[k].predecessors || []) if (Math.abs(plan[p][1] - plan[k][0]) < 0.01) stack.push(p);
    }
    return {
        total: end,
        activities: activities.map(a => ({ ...a, duration_min: Number(a.duration_min) || 0, offset_min: Number(a.offset_min) || 0,
            base_start_min: plan[a.key][0], base_end_min: plan[a.key][1], critical: crit.has(a.key), timing: 'sin_iniciar' })),
    };
}

export const AREAS = ['Despacho', 'Tripulaciones', 'Aeropuerto', 'Rampa', 'Mantenimiento', 'Capitán', 'Piloto', 'Tripulante de cabina'];
